export default __webpack_public_path__ + "static/media/review4.6cd1f728.jpg";